import Lottie from 'lottie-react';
import { ReactNode } from 'react';
import styles from './AnimatedLoader.module.css';
import Loading from './animations/loading.json';

const Animation = {
  Loading: 'Loading',
} as const;

type Animation = (typeof Animation)[keyof typeof Animation];

const AnimationMap: Record<Animation, object> = {
  Loading,
};

interface AnimatedLoaderProps {
  children: ReactNode;
  animation?: Animation;
}

const AnimatedLoader = ({ animation, children }: AnimatedLoaderProps) => {
  const selectedAnimation = AnimationMap[animation || Animation.Loading];

  return (
    <div className={styles.container}>
      <Lottie animationData={selectedAnimation} />
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default AnimatedLoader;
